// extracted by mini-css-extract-plugin
module.exports = {"--full-screen":"Tiles__--full-screen__vJDeX","tiles__container":"Tiles_tiles__container____YKb"};